import React, { useEffect, useState } from "react";
import filteringProps from "../filtering/jobmetros.json";
import { DataForm, DataTable, DataTableField } from "../../../../components/data/DataTable";
import { API_ROUTES } from '../../../../core/Constants';
import { getUser, hasRole, setPage, toPrettyDate, useEnvironment, useHub } from '../../../../core/Global';
import { DrawerForm } from "../../../../components/drawers/DrawerForm";
import Icon from "../../../../components/base/Icon";
import FlexRow from "../../../../components/base/FlexRow";
import { Link } from "react-router-dom";
import Avatar from "../../../../components/base/Avatar";
import JobMetro from "../models/JobMetro";
import MetroEditModal from "./MetroEditModal";
import MetroFormDrawer from "./MetroFormDrawer";
import DataTableActiveToggle from "../../../../components/data/DataTableActiveToggle";
import TechPoolSelector from "../components/TechPoolSelector";

function MetrosList() {

  const user = getUser()
  const hub = useHub()
  const [refresh, refreshSet] = useState<boolean>();

  const [createMetro, createMetroSet] = useState<boolean>(false);
  const [editMetro, editMetroSet] = useState<boolean>(false);
  const [techsModal, techsModalSet] = useState<boolean>(false);
  const [techIds, techIdsSet] = useState<string[]>();
  const [priorityTechIds, priorityTechIdsSet] = useState<string[]>();

  const [selectedItem, selectedItemSet] = useState<JobMetro>();

  useEffect(() => {
    techIdsSet(selectedItem?.techIds)
    priorityTechIdsSet(selectedItem?.priorityTechIds)
  }, [selectedItem])


  const add = () => {
    createMetroSet(true);
  }

  const edit = (data: any) => {
    selectedItemSet(data);
    editMetroSet(true);
  }



  const NameItem = (data: any) => (
    <FlexRow onClick={() => edit(data)}>
      <Icon icon="circle" type="solid" size={16} className="me-2" color={data.color} />
      <div>
        {data.name}
      </div>
    </FlexRow>
  )

  const TechsItem = (data: JobMetro) => {
    const count = data.techs?.length ?? 0
    return (
      <a href="#" className={"d-flex align-items-center" + (count > 0 ? "" : " text-gray-500 fs-8")}
        onClick={e => {
          e.preventDefault();
          selectedItemSet(data);
          techsModalSet(true)
        }}>
        {
          count > 0
            ?
            <>
              <Icon icon="user-helmet-safety" className="me-2" size={13} />
              <span>{count} {count > 1 ? "Technicians" : "Technician"}</span>
            </>
            :
            <span>[Assign Technician]</span>
        }
      </a>
    )
  }

  const UserItem = (data: any) => (
    <div>
      <div>
        {data.ownerUser?.fullName ?? "System Metro"}
      </div>
      {
        data.creatorUser &&
        <div className='d-flex align-items-center fs-8 mt-1'>
          <Icon icon="user" className="me-1" size={12} />
          <span>
            created by: {data.creatorUser?.username}
          </span>
        </div>
      }
    </div>
  )

  const CreatedItem = (data: JobMetro) => (
    <div>
      <div className='d-flex align-items-center'>
        {toPrettyDate(data.createdAt)}
      </div>
      {
        data.creatorUser &&
        <FlexRow className='fs-8 text-gray-600 mt-1'>
          <div>
            <Icon icon="user" className="me-2" size={10} type="solid" />
          </div>
          <div className="fs-8">
            By: {data.creatorUser.fullName}
          </div>
        </FlexRow>
      }

    </div>
  )

  useEffect(() => {
    setPage("Metros", "CRM", "Base Data");



    window.onModalOpen("modal-rename-metro", () => {
      $("#txt-rename-name").focus();
      $("#txt-rename-name").select();
    });

  }, []);

  useEffect(() => {
    if (refresh) {
      setTimeout(() => {
        refreshSet(false);
      }, 1000);
    }


  }, [refresh])

  return (
    <>
        <DataTable
          objectName="Metro"
          apiRoute={API_ROUTES.JobMetros}
          route="/system/base/metros"
          ascending
          filteringProps={filteringProps}
          edit editCustom={edit} addCustom={add}
          delete={hasRole("DeleteMetros")}
          refresh={refresh}>
          <DataTableField title="" width={50}>
            <DataTableActiveToggle route={API_ROUTES.JobMetros} />
          </DataTableField>
          <DataTableField title="Name">
            <NameItem />
          </DataTableField>
          <DataTableField title="Country" dataValueName="countryName" />
          <DataTableField title="State" dataValueName="stateName" />
          <DataTableField title="Technicians">
            <TechsItem />
          </DataTableField>
          <DataTableField title="Owner User" hidden={!user?.isSuperAdmin}>
            <UserItem />
          </DataTableField>

          <DataTableField title="Created">
            <CreatedItem />
          </DataTableField>

        </DataTable>


      {
        createMetro &&
        <MetroFormDrawer
          onClose={() => {
            selectedItemSet(undefined)
            createMetroSet(false)
          }}
          onSubmit={() => refreshSet(true)} />
      }

      {
        editMetro && selectedItem &&
        <MetroFormDrawer metro={selectedItem}
          onClose={() => {
            selectedItemSet(undefined)
            editMetroSet(false)
          }}
          onSubmit={() => refreshSet(true)} />
      }

      {
        techsModal && selectedItem &&
        <DrawerForm id="drawer-metro-techs"
          title={`${selectedItem?.name}: Technicians`}
          size="xlarge"
          buttonText="Update Technicians"
          onClose={() => {
            selectedItemSet(undefined)
            techsModalSet(false)
          }}
          onSubmit={(body, callback) => {
            hub.Post(API_ROUTES.JobMetros + "techs", {
              id: selectedItem.id,
              techIds: techIds,
              priorityTechIds: priorityTechIds
            }, res => {
              if (res.success) refreshSet(true)
              callback?.(res)
            })
          }}
        >
          <TechPoolSelector selectedTechIds={selectedItem.techIds}
            priorityTechIds={selectedItem.priorityTechIds}
            onChange={ids => techIdsSet(ids)}
            onPriorityChange={ids => priorityTechIdsSet(ids)} />
        </DrawerForm>
      }



    </>
  );
}

export default MetrosList;
